var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"menu-list-item body__medium"},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }